angular.module('property-deal')
    .component('propertyDealDashboard', {
        bindings: {
        },
        templateUrl: 'app/property-deal/dashboard/dashboard.html',
        controller: function ($scope, PropertyDealService, Principal, $http) {
            this.PropertyDealService = PropertyDealService
            this.activeUsersOnly = true

            this.$onInit = () => {
                this.refreshPermissionsAndData()
                this.unwatchAuthenticationChanged = $scope.$on('authenticationChanged', () => this.refreshPermissionsAndData())
            }

            this.$onDestroy = () => {
                if (angular.isFunction(this.unwatchAuthenticationChanged)) {
                    this.unwatchAuthenticationChanged()
                }
            }

            this.refreshPermissionsAndData = () => {
                Principal.hasAnyAuthorityPromise(["ROLE_PROPERTY_DEAL"]).then(isManager => {
                    this.isManager = isManager
                    if (isManager) {
                        this.loadStatistics()
                    } else {
                        this.data = null
                    }
                })
            }

            this.loadStatistics = () => {
                return $http.get('/crm/api/property-deal/user-statistics').then(response => {
                    this.data = response.data;
                }).catch(() => {
                    this.data = null
                });
            }

            this.managerStatisticsFilter = item => {
                return !this.activeUsersOnly || this.isActiveUser(item && item.user)
            }

            this.isActiveUser = user => {
                return !!(user && user.activated !== false && user.active !== false)
            }

            this.filteredManagerStatistics = () => {
                if (!this.data || !angular.isArray(this.data.managerStatistics)) {
                    return []
                }
                return this.data.managerStatistics.filter(this.managerStatisticsFilter)
            }
        }
    })
    .component('propertyDealTimelineDashboard', {
        bindings: {
        },
        templateUrl: 'app/property-deal/dashboard/timeline-dashboard.html',
        controller: function ($scope, Principal, $http) {
            this.timeline = []
            this.managers = []
            this.selectedManager = null
            this.selectedProjects = []
            this.activePopoverItem = null

            this.$onInit = () => {
                this.refreshPermissionsAndData()
                this.unwatchAuthenticationChanged = $scope.$on('authenticationChanged', () => this.refreshPermissionsAndData())
            }

            this.$onDestroy = () => {
                if (angular.isFunction(this.unwatchAuthenticationChanged)) {
                    this.unwatchAuthenticationChanged()
                }
            }

            this.refreshPermissionsAndData = () => {
                Principal.hasAnyAuthorityPromise(["ROLE_PROPERTY_DEAL"]).then(isManager => {
                    this.isManager = isManager
                    if (isManager) {
                        this.loadStatistics()
                    } else {
                        this.timeline = []
                        this.managers = []
                        this.selectedProjects = []
                    }
                })
            }

            this.loadStatistics = () => {
                let params = this.dashboardParams()
                return $http.get('/crm/api/property-deal/user-statistics', {params}).then(response => {
                    this.managers = this.extractManagers(response.data && response.data.salesManagers)
                    this.timeline = this.buildTimeline(response.data && response.data.timelineStatistics)
                }).catch(() => {
                    this.managers = []
                    this.timeline = []
                });
            }

            this.dashboardParams = () => {
                let params = {}
                let projectIds = this.selectedProjectIds()
                if (this.selectedManager) {
                    params.managerId = this.selectedManager.id
                }
                if (projectIds.length) {
                    params.projectIds = projectIds
                }
                return params
            }

            this.selectedProjectIds = () => this.projectIds(this.selectedProjects)

            this.projectIds = projects => {
                if (!angular.isArray(projects)) {
                    projects = projects == null ? [] : [projects]
                }
                return projects
                    .map(project => angular.isObject(project) ? project.id : project)
                    .filter(projectId => projectId != null && projectId !== '')
            }

            this.timelineFilters = item => {
                let params = {
                    periodStart: item.month + '-01',
                    periodEnd: moment(item.month + '-01').endOf('month').format('YYYY-MM-DD'),
                    status: ['SOLD', 'TRANSFERRED', 'FINISHED'],
                    agreementType: ['DEVELOPMENT', 'PRELIMINARY_SALE', 'CONDITIONAL_SALE'],
                    customFilter: 'included-in-statistics',
                    page: null
                }
                let projectIds = this.selectedProjectIds()
                if (this.selectedManager) {
                    params.manager = this.selectedManager.id
                }
                if (projectIds.length) {
                    params.project = projectIds
                }
                return params
            }

            this.extractManagers = items => {
                if (!items || !items.length) {
                    return []
                }

                return items
                    .filter(item => item && item.id)
                    .sort((a, b) => (a.fullName || '').localeCompare(b.fullName || ''))
            }

            this.onManagerFilterChanged = () => this.loadStatistics()
            this.onProjectFilterChanged = selected => {
                if (angular.isArray(selected)) {
                    this.selectedProjects = selected
                }
                return this.loadStatistics()
            }

            this.buildTimeline = items => {
                if (!items || !items.length) {
                    return []
                }

                let max = Math.max.apply(null, items.map(item => (item.developmentCount || 0) + (item.preliminarySaleCount || 0) + (item.conditionalSaleCount || 0))) || 1
                return items.map(item => {
                    let developmentCount = item.developmentCount || 0
                    let preliminarySaleCount = item.preliminarySaleCount || 0
                    let conditionalSaleCount = item.conditionalSaleCount || 0
                    let total = developmentCount + preliminarySaleCount + conditionalSaleCount

                    return {
                        month: item.month,
                        label: item.label,
                        developmentCount: developmentCount,
                        preliminarySaleCount: preliminarySaleCount,
                        conditionalSaleCount: conditionalSaleCount,
                        total: total,
                        totalHeight: Math.max((total / max) * 100, total ? 8 : 0),
                        developmentShare: total ? (developmentCount / total) * 100 : 0,
                        preliminaryShare: total ? (preliminarySaleCount / total) * 100 : 0,
                        conditionalShare: total ? (conditionalSaleCount / total) * 100 : 0
                    }
                })
            }
        }
    })
